import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ExecuteEquityContractRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ExecuteEquityContractResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const executeEquityContract = (request: ExecuteEquityContractRequest, options?: CashRequestOptions) =>
  post<ExecuteEquityContractRequest, ExecuteEquityContractResponse>('/2.0/cash/execute-equity-contract', request, {
    ...options,
    rejectOnError: true,
  })
